'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _omalomaService = require('../../../winresCloud/omalomaService');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[BookingPicker]');

var WinresOmalomaBookingPickerController = function () {
  function WinresOmalomaBookingPickerController($rootScope, $scope, omalomaService, $location) {
    _classCallCheck(this, WinresOmalomaBookingPickerController);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.$location = $location;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // loading - Trying to load bookings.
    // ready - Loaded bookings.
    // error - Failed to load bookings.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Failed to fetch bookings.
    this.$scope.error = null;

    this.$scope.bookings = [];
    this.$scope.selected = null;

    this.locationHash = this.$location.search().booking;
    console.log("locationhash 'booking' is: ", this.locationHash);
  }

  _createClass(WinresOmalomaBookingPickerController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.setStatus('out', null);
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      this.setStatus('loading', null);
      this.omalomaService.getBookingList().then(function (result) {
        if (result === null) {
          throw 'Backend returned null.';
        }
        return result;
      }).then(function (bookings) {
        _this2.$scope.bookings = _.compact(_.map(bookings, collateBookingInfo));
        _this2.$scope.bookings = _.reverse(_.sortBy(_this2.$scope.bookings, function (booking) {
          return moment(booking.startDate);
        }));

        console.log("[WOBP] bookings object is: ", bookings);
        if (bookings.length <= 0) {
          _this2.setStatus('error', 'notice', 'no_bookings');
          _this2.$rootScope.$broadcast("no-bookings"); // Broadcast no-bookings to winresOmalomaBookingSummary.js
          return;
        }
        var closestBookingNumber = _this2.chooseClosestToDate();
        _this2.setStatus('ready', null);

        _this2.checkForHashBookingNumber(_this2.locationHash, closestBookingNumber);
      }).catch(function (error) {
        console.error('[WOBP] Failed to load bookings:', error);
        _this2.setStatus('error', 'notice', 'malfunction');
        //this.setStatus('no-bookings', null);
        //this.setStatus('error', 'no_bookings');
        //this.$rootScope.$broadcast("no-bookings");
      });
    }
  }, {
    key: 'chooseClosestToDate',
    value: function chooseClosestToDate() {
      var nowDate = new Date().getTime();
      var tempArr = [];
      this.$scope.bookings.forEach(function (elem, ind) {
        elem.millisecondsDate = new Date(elem.startDate).getTime();
        tempArr.push(elem);
      });
      tempArr.sort(function (a, b) {
        var tempNumber = nowDate - a.millisecondsDate;
        a.diff = tempNumber;
        b.diff = nowDate - b.millisecondsDate;
        return tempNumber;
      });
      return tempArr[0].number;
    }
  }, {
    key: 'pick',
    value: function pick(bookingNumber) {
      this.$scope.selected = bookingNumber;
      console.log('[WOBP] Picked booking:', bookingNumber);
      this.onChange({ number: bookingNumber });

      // Set booking to URL Hash
      //this.$location.hash(bookingNumber);
      this.$location.search('booking', bookingNumber);
      window.location.hash = window.location.hash.replace(/#tab.*/, '');

      window.closeCustomerInfoTab();
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, notice, error) {
      this.$scope.status = status;
      console.log('[WOBP] Set status to', status);
      if (error !== undefined) {
        if (error) {
          console.error('[WOBP] Error:', error);
          this.$scope.error = error;
        }
      }
    }

    // Check if there is hash and if hash in number select a booking with that number
    // if not select the first booking in list

  }, {
    key: 'checkForHashBookingNumber',
    value: function checkForHashBookingNumber(locationHash, closestBookingNumber) {
      if (locationHash) {
        console.log("Location Hash is: ", locationHash);
        if (!isNaN(locationHash)) {
          console.log("Location Hash is a number! ", locationHash);
          this.pick(locationHash);
        }
      } else {
        if (closestBookingNumber) {
          this.pick(closestBookingNumber);
          console.log("[WOBP] Selected first booking from the list. firstBookingNumber is:", closestBookingNumber);
        } else {
          console.error("[WOBP] Tried to select first booking. There was nothing");
        }
      }
    }
  }]);

  return WinresOmalomaBookingPickerController;
}();

function collateBookingInfo(booking) {
  var info = booking.BookInfos;
  var hi = (0, _omalomaService.headerInfoFromBooking)(booking);

  if (hi === null) {
    log.warning('Booking header info is null', info);
    return null;
  }

  var defaultImageURL = "https://omalomat.fi/wp-content/uploads/2016/05/bonalba14_rajattu_pieni.jpg";

  return {
    number: info.BookingNumber,
    startDate: hi && hi.BeginDate || '',
    destination: hi && hi.Subtitle || '',
    data: booking,
    image: hi && hi.Image || defaultImageURL
  };
}

WinresOmalomaBookingPickerController.$inject = ['$rootScope', '$scope', 'omalomaService', '$location'];

_module3.default.component('winresOmalomaBookingPicker', {
  template: require('./winresOmalomaBookingPicker.html'),
  controller: WinresOmalomaBookingPickerController,
  require: {},
  bindings: {
    connectionName: '@',
    onChange: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaBookingPicker/winresOmalomaBookingPicker.js
// module id = 325
// module chunks = 2